import { render, staticRenderFns } from "./ScopeExhibits.vue?vue&type=template&id=887493d8&"
import script from "./ScopeExhibits.vue?vue&type=script&lang=js&"
export * from "./ScopeExhibits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports